import * as React from "react";
import {Fragment, Component} from "react";
import Diagram from "../../assets/Diagram.svg"

class Measure extends Component {

	constructor(props) {
		super(props);
		this.state = {
			width: 0,
			droppingOut: 0
		}
	}

	componentDidMount() {
		const width = document.getElementById('slider-breite');
		const droppingOut = document.getElementById('ausfall');
		if(width && droppingOut) {
			this.setState({width: width.value});
			this.setState({droppingOut: droppingOut.value});
		}
	}

	render() {

		const {width, droppingOut} = this.state;

		return (
			<Fragment>
				{width > 0 && droppingOut > 0 ?
					<div className="ruler">
						<Fragment>
							<div className="width">
								{width} mm
							</div>
							<div className="droppingOut">
								{droppingOut} mm
							</div>
							<img src={Diagram} alt="" />
						</Fragment>
					</div>
					:
					<Fragment>
						Bitte definieren Sie Breite und Ausfall.
					</Fragment>
				}
			</Fragment>
		);
	}
}

export default Measure;
